import React from 'react';
import { TreePineIcon, GiftIcon, StoreIcon } from 'lucide-react';
import { opportunityItems } from '../data/opportunity';
import { SectionHeading } from './ui/SectionHeading';
const icons = {
  tree: TreePineIcon,
  gift: GiftIcon,
  store: StoreIcon
};
export function Opportunity() {
  return <section className="w-full bg-bone py-14 sm:py-20 lg:py-24" data-id="element-130" data-mp="2c3734fbbj5uh">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-131" data-mp="2c0kyanftb4fy">
        <SectionHeading overline="Oportunidad navideña" title={<>
              La Navidad es el mejor momento para convertir una idea creativa en{' '}
              <span className="italic text-terracotta-500" data-id="element-133" data-mp="2qrlddbb2dwl2">una oportunidad</span>
            </>} subtitle={<>
              Durante los últimos meses del año aumenta la búsqueda de regalos,
              decoración y productos personalizados. Con materiales simples
              puedes crear piezas únicas para tu hogar o comenzar un pequeño
              emprendimiento navideño con baja inversión.
            </>} data-id="element-132" data-mp="2h0qu8ft47d3u" />

        <ul className="mt-9 grid gap-4 sm:mt-12 sm:grid-cols-3 sm:gap-6" data-id="element-134" data-mp="ye06mljsl6xl">
          {opportunityItems.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex items-start gap-4 rounded-3xl border border-gold-200/50 bg-cream p-5 shadow-[0_18px_40px_-30px_rgba(14,35,21,0.5)] sm:flex-col sm:gap-0 sm:rounded-4xl sm:p-7" data-id="element-135" data-mp="udzpgt5b6hmu">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-sage-800 text-gold-200 sm:h-12 sm:w-12" data-id="element-136" data-mp="1i1hon9qwkhzu">
                  <Icon className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" data-id="element-137" data-mp="1d3fv1uvup0a4" />
                </span>
                <div data-id="element-138" data-mp="18ad9oa188x50">
                  <h3 className="font-serif text-[1.35rem] leading-tight text-sage-800 sm:mt-5 sm:text-[1.55rem]" data-id="element-139" data-mp="189ttoyv50itm">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-ink-soft sm:mt-3 sm:text-[14.5px]" data-id="element-140" data-mp="20t0nr5ht3bwl">
                    {item.body}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}